import styled from 'styled-components'
import theme from '../../styles/theme'

const StMenu = styled.div`
  width: 0px;
  position: fixed;
  top: ${theme.headerHeight};
  bottom: 0;
  right: 0;
  z-index: 2;
  overflow-y: scroll;
  overflow-x: hidden;
  transition: width .3s ease-out;
  will-change: width;
  &.active{
    width: 100vw;
  }
  .menu-wrap{
    background: black;
    width: 100vw;
    padding: 1rem;
    .link{
      display: block;
      text-align: right;
      font-size: 1.6rem;
      font-weight: bold;
      border-bottom: 1px solid white;
      padding-bottom: 8px;
      margin-bottom: 8px;
      span{
        display: block;
      }
      .tituloRuso{
        font-size: 1rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .tituloEspanol{
        color: white;
      }
    }
  }
`

export { StMenu }